import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from '../../../shared/api.service';
import { PollItemData } from '../../../models/PollItemData';
import { PollDashboardResponse } from '../../../models/PollDashBoardResponse';
import { AuthenticationService } from '../../../shared/authentication.service';
import { LicenseService } from '../../../shared/licens.service';
import { SubsciptionData, LicenseData } from '../../../models/LicenseData';
import { Common } from '../../../shared/common';
import { Application, VotingPeriod, ElectionVenue } from 'src/app/pap-creation/pap-dto/pap-dto';

@Component({
  selector: 'app-pap-application',
  templateUrl: 'pap-application.component.html',
  styleUrls: ['./pap-application.component.less', '../../../shared/common.less'],
})

export class PapApplicationComponent implements OnInit {
  @Input() application: Application;
  @Input() venue: ElectionVenue;
  @Input() period: VotingPeriod;
  @Output() applicationChange = new EventEmitter<Application>();

  needPap: boolean = undefined;
  minDate: string;
  maxDate: string;
  secondRoundMaxDate: string;
  hasMailOption: boolean = false;
  hasEMailOption: boolean = false;
  hasHandOption: boolean = false;

  constructor(
    private router: Router,
  ) {
    const today = new Date();
    this.minDate = today.toISOString().substring(0, 10);
  }

  onApplicationChange() {
    this.applicationChange.emit(this.application);
  }

  get firstRoundLimitString(): string {
    return this.application.firstRoundLimit && this.application instanceof Date
      ? this.application.firstRoundLimit.toISOString().substring(0, 10)
      : '';
  }

  set firstRoundLimitString(value: string) {
    if (value) {
      if (!this.application.firstRoundLimit) {
        this.application.firstRoundLimit = new Date(value);
      } else {
        const currentTime = this.application.firstRoundLimit;
        const newDate = new Date(value);
        newDate.setHours(currentTime.getHours(), currentTime.getMinutes(), 0, 0);
        this.application.firstRoundLimit = newDate;
      }
    } else {
      this.application.firstRoundLimit = null;
    }
    this.onApplicationChange();
  }

  get firstRoundLimitTime(): string {
    if (!this.application.firstRoundLimit || !(this.application.firstRoundLimit instanceof Date)) { return ''; }
    const hours = this.application.firstRoundLimit.getHours().toString().padStart(2, '0');
    const minutes = this.application.firstRoundLimit.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  }

  set firstRoundLimitTime(value: string) {
    if (!this.application.firstRoundLimit) {
      this.application.firstRoundLimit = new Date();
    }
    const [hours, minutes] = value.split(':').map(Number);
    this.application.firstRoundLimit.setHours(hours, minutes, 0, 0);
    this.onApplicationChange();
  }

  get secondRoundLimitString(): string {
    return this.application.secondRoundLimit && this.application.secondRoundLimit instanceof Date
      ? this.application.secondRoundLimit.toISOString().substring(0, 10)
      : '';
  }

  set secondRoundLimitString(value: string) {
    if (value) {
      if (!this.application.secondRoundLimit) {
        this.application.secondRoundLimit = new Date(value);
      } else {
        const currentTime = this.application.secondRoundLimit;
        const newDate = new Date(value);
        newDate.setHours(currentTime.getHours(), currentTime.getMinutes(), 0, 0);
        this.application.secondRoundLimit = newDate;
      }
    } else {
      this.application.secondRoundLimit = null;
    }
    this.onApplicationChange();
  }

  get secondRoundLimitTime(): string {
    if (!this.application.secondRoundLimit || !(this.application.secondRoundLimit instanceof Date)) { return ''; }
    const hours = this.application.secondRoundLimit.getHours().toString().padStart(2, '0');
    const minutes = this.application.secondRoundLimit.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  }

  set secondRoundLimitTime(value: string) {
    if (!this.application.secondRoundLimit) {
      this.application.secondRoundLimit = new Date();
    }
    const [hours, minutes] = value.split(':').map(Number);
    this.application.secondRoundLimit.setHours(hours, minutes, 0, 0);
    this.onApplicationChange();
  }

  goToPollCreation() {
    this.router.navigate(['/poll-creation']);
  }

  ngOnChanges(): void {
    if (this.period.fROpening instanceof Date) {
      this.maxDate = this.period.fROpening.toISOString().substring(0, 10);
    }

    if (this.period.sROpening instanceof Date) {
      this.secondRoundMaxDate = this.period.sROpening.toISOString().substring(0, 10);
    }
  }

  ngOnInit(): void {
    if (this.venue) {
      this.application.address = this.venue.address;
      this.application.zip = this.venue.zipcode;
      this.application.city = this.venue.city;
    }
  }
}
